import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";

export const GetManualWageBulkStageHelper = async () => {
  return await axiosInstance(`/finance/getManualWageBulkStage`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
    },
  })
    .then((res) => {
      return { message: "Update Success", hasError: false, data: res?.data };
    })
    .catch((err) => {
      return {
        message: "Unable to update",
        hasError: false,
        data: err?.response?.data,
      };
    });
};

export const UpdateManualWageBulkStageHelper = async (params) => {
  return await axiosInstance(`/finance/updateManualWageBulkStage`, {
    method: "PUT",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      adjustments_details_json: params?.adjustments_details_json,
      adjustment_component_detail_stage_pk:
        params?.adjustment_component_detail_stage_pk,
    },
  })
    .then((res) => {
      return { message: "Update Success", hasError: false, data: res?.data };
    })
    .catch((err) => {
      return {
        message: "Unable to update",
        hasError: false,
        data: err?.response?.data,
      };
    });
};

export const DeleteManualWageBulkStageHelper = async (params) => {
  return await axiosInstance(`/finance/deleteManualWageBulkStage`, {
    method: "DELETE",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      adjustment_component_detail_stage_pk:
        params?.adjustment_component_detail_stage_pk || null,
    },
  })
    .then((res) => {
      return { message: "Success", hasError: false, data: res?.data };
    })
    .catch((err) => {
      return {
        message: "Failed to delete",
        hasError: false,
        data: err?.response?.data,
      };
    });
};

export const AddManualWageBulkStagetoMainHelper = async (params) => {
  return await axiosInstance(`/finance/addManualWageBulkStagetoMain`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
    },
  })
    .then((res) => {
      return { message: "Success", hasError: false, data: res?.data };
    })
    .catch((err) => {
      return { message: "Unable", hasError: false, data: err?.response?.data };
    });
};
